var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"thumbsnav"},[_c('div',{staticClass:"thumbcont"},[_c('carousel',{attrs:{"scrollPerPage":false,"perPageCustom":[[480, 3],
      [510, 4],
      [630, 5],
      [750, 6],
      [970, 7],
      [990, 8],
      [1110, 9],
      [1230, 10],
      [1350, 11]],"mouse-drag":true,"navigateTo":_vm.$store.state.currentStep-1,"paginationEnabled":false}},_vm._l((_vm.$store.state.items),function(item,key){return _c('slide',{key:key,class:'thumb'+_vm.thumbClass(key)+' num'+(key+1),attrs:{"data-index":key},on:{"slideclick":function($event){return _vm.gotoSlide(key)}}},[_c('img',{attrs:{"src":'./images/' + item[1].thumb,"alt":item[0]}}),_c('div',{staticClass:"filter"})])}),1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }